import { render } from "./AddWorkerToDepartmentAdmin.vue?vue&type=template&id=6c25d201&scoped=true&ts=true"
import script from "./AddWorkerToDepartmentAdmin.vue?vue&type=script&lang=ts"
export * from "./AddWorkerToDepartmentAdmin.vue?vue&type=script&lang=ts"

import "./AddWorkerToDepartmentAdmin.vue?vue&type=style&index=0&id=6c25d201&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c25d201"]])

export default __exports__